<script setup lang="ts">
const songStore = useSongStore();
const store = useMediaPlayerStore();
</script>

<template>
  <Transition name="fade">
    <div
      v-if="!songStore.loading"
      id="MediaPlayer"
    >
      <SlideTransition :show="!!store.nowPlaying">
        <NowPlayingFull />
      </SlideTransition>
      <div class="media-list">
        <MediaPlayerStickyList />
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="postcss">
#MediaPlayer {
  @apply rounded-xl bg-white bg-opacity-5;
}
.media-list {
  @apply p-5 pb-1;
}
.media-player-expanded {
  @apply flex min-h-24 flex-col items-start justify-between gap-2 rounded-none bg-white bg-opacity-5 px-2 py-3 sm:min-h-0 sm:flex-row sm:items-center sm:gap-5 sm:px-5;
}
.now-playing-wrapper {
  @apply ms-0 flex w-full flex-1 items-center gap-2 sm:ms-8 xl:ms-20;
}
</style>
